import { actionTypesMaker } from 'redux/lib/utils';

const actionTypes = [
    'GET_USER_ANALYSE_SUCCESS', // 获取用户可用的转化指标
    'SET_SELECTED_TAGS', // 设置选中标签
    'GET_MAX_DATE_SUCCESS',
];

export default actionTypesMaker('report', actionTypes);
